import React from "react";
import { useLanguage } from "../context/LanguageContext";

const CONFERENCES = [
  { year: "2018", city: "Cordoba, Argentine", event: "3rd Int. Course in Medicine and Sports Traumatology", role_fr: "Conférencier invité", role_en: "Invited speaker" },
  { year: "2018", city: "Viseu, Portugal", event: "38° Congresso Nacional de Ortopedia e Traumatologia (SPOT)", role_fr: "Directeur de table ronde", role_en: "Round-table chair" },
  { year: "2017", city: "Marseille, France", event: "SFA — Société Française d'Arthroscopie", role_fr: "Table ronde implants de coiffe", role_en: "Cuff implants round-table" },
  { year: "2017", city: "Paris, France", event: "SOFEC — Symposium instabilité épaule", role_fr: "Directeur du symposium", role_en: "Symposium director" },
  { year: "2016", city: "Paris, France", event: "SOFCOT — Session échographie", role_fr: "Directeur de séance", role_en: "Session director" },
  { year: "2015", city: "Grenoble, France", event: "SFA — Complications neurologiques de l'arthroscopie", role_fr: "Directeur de table ronde", role_en: "Round-table chair" },
  { year: "2013", city: "Paris, France", event: "Institut de la Main Jouvenet — Symposium international", role_fr: "Conférencier technique In box", role_en: "In-box technique speaker" },
  { year: "2011", city: "Lyon, France", event: "SECEC — Société Européenne de l'Épaule et du Coude", role_fr: "Communication scientifique", role_en: "Scientific communication" },
  { year: "2009", city: "Deauville, France", event: "SFA — Approche intra-articulaire coiffe", role_fr: "Communication — 300 cas", role_en: "Communication — 300 cases" },
  { year: "1999", city: "Rochester, USA", event: "Mayo Clinic — Hand conferences", role_fr: "Communication anatomique", role_en: "Anatomical communication" },
];

const PRESS = [
  { outlet: "Maîtrise Orthopédique", title_fr: "Luxation postérieure sterno-claviculaire — mise au point", title_en: "Posterior sterno-clavicular dislocation — update", year: "2002" },
  { outlet: "SportMed", title_fr: "Les luxations acromio-claviculaires — médical ou chirurgical ?", title_en: "Acromio-clavicular dislocations — medical or surgical?", year: "2004" },
  { outlet: "AJR American Journal of Roentgenology", title_fr: "Preoperative imaging of shoulder instability", title_en: "Preoperative imaging of shoulder instability", year: "2012" },
  { outlet: "Orthop & Traumatology: Surgery & Research", title_fr: "Revision of Latarjet by Eden-Hybinette technique", title_en: "Revision of Latarjet by Eden-Hybinette technique", year: "2018" },
];

const MediaConferences = () => {
  const { lang } = useLanguage();

  return (
    <section
      id="media"
      data-testid="media-section"
      className="section-padding bg-white"
    >
      <div className="container-page">
        <div className="max-w-3xl">
          <span className="chip mb-5">
            {lang === "fr" ? "Conférences & médias" : "Conferences & media"}
          </span>
          <h2 className="font-display font-black text-4xl sm:text-5xl text-navy leading-[1.05]">
            {lang === "fr"
              ? "Une voix reconnue par la communauté scientifique"
              : "A voice recognized by the scientific community"}
          </h2>
          <p className="mt-5 text-base md:text-lg text-foreground/75 leading-relaxed">
            {lang === "fr"
              ? "Plus de 80 communications scientifiques internationales, conférences invitées et symposiums dirigés — de Marseille à la Mayo Clinic, en passant par Cordoba, Paris, Lyon et Viseu."
              : "Over 80 international scientific communications, invited lectures and chaired symposiums — from Marseille to Mayo Clinic via Cordoba, Paris, Lyon and Viseu."}
          </p>
        </div>

        <div className="mt-12 grid lg:grid-cols-12 gap-10">
          {/* Conferences timeline */}
          <div className="lg:col-span-7">
            <h3 className="font-display font-bold text-navy text-xl mb-5 flex items-center gap-2">
              <i className="fa-solid fa-microphone text-[#FF5A1F]" aria-hidden="true"></i>
              {lang === "fr" ? "Sélection de conférences" : "Selected lectures"}
            </h3>
            <ol className="space-y-4">
              {CONFERENCES.map((c, i) => (
                <li
                  key={i}
                  data-testid={`conference-${i}`}
                  className="group flex items-start gap-4 rounded-xl border border-border bg-white p-4 hover:border-[#FF5A1F]/40 hover:shadow-md transition-all"
                >
                  <span className="inline-flex h-10 w-14 shrink-0 items-center justify-center rounded-md bg-[#0A192F] text-white font-display font-bold text-sm">
                    {c.year}
                  </span>
                  <div className="flex-1 min-w-0">
                    <p className="font-display font-bold text-navy text-sm md:text-base">
                      {c.event}
                    </p>
                    <p className="mt-1 text-xs text-muted-foreground">
                      <i className="fa-solid fa-location-dot text-[#FF5A1F] mr-1" aria-hidden="true"></i>
                      {c.city}
                      <span className="mx-2">·</span>
                      <span className="text-[#FF5A1F] font-semibold">
                        {lang === "fr" ? c.role_fr : c.role_en}
                      </span>
                    </p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          {/* Press + stats */}
          <div className="lg:col-span-5 space-y-6">
            <div className="rounded-2xl bg-[#0A192F] text-white p-6">
              <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-white/50">
                {lang === "fr" ? "Rayonnement" : "Reach"}
              </p>
              <div className="mt-5 grid grid-cols-2 gap-4">
                <div>
                  <p className="font-display text-3xl font-extrabold text-[#FF5A1F]">80+</p>
                  <p className="text-xs text-white/70 mt-1">
                    {lang === "fr" ? "Communications" : "Communications"}
                  </p>
                </div>
                <div>
                  <p className="font-display text-3xl font-extrabold text-[#FF5A1F]">40+</p>
                  <p className="text-xs text-white/70 mt-1">
                    {lang === "fr" ? "Publications" : "Publications"}
                  </p>
                </div>
                <div>
                  <p className="font-display text-3xl font-extrabold text-[#FF5A1F]">12</p>
                  <p className="text-xs text-white/70 mt-1">
                    {lang === "fr" ? "Pays visités" : "Countries"}
                  </p>
                </div>
                <div>
                  <p className="font-display text-3xl font-extrabold text-[#FF5A1F]">25+</p>
                  <p className="text-xs text-white/70 mt-1">
                    {lang === "fr" ? "Années carrière" : "Career years"}
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h3 className="font-display font-bold text-navy text-xl mb-5 flex items-center gap-2">
                <i className="fa-solid fa-newspaper text-[#FF5A1F]" aria-hidden="true"></i>
                {lang === "fr" ? "Dans la presse scientifique" : "Scientific press"}
              </h3>
              <ul className="space-y-3">
                {PRESS.map((p, i) => (
                  <li
                    key={i}
                    data-testid={`press-${i}`}
                    className="rounded-xl border border-border bg-white p-4"
                  >
                    <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#FF5A1F]">
                      {p.outlet} · {p.year}
                    </p>
                    <p className="mt-1.5 text-sm font-semibold text-navy leading-tight">
                      {lang === "fr" ? p.title_fr : p.title_en}
                    </p>
                  </li>
                ))}
              </ul>
              <a
                href="/publications"
                className="mt-4 inline-flex link-underline text-sm"
              >
                {lang === "fr" ? "Voir toutes les publications" : "See all publications"}
                <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaConferences;
